/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

/**
 * If set, send reminder emails to participants N hours before the session (1-168 hours = 1 week). If None, no reminders are sent.
 */
export type EventKindSendParticipantReminderHoursBefore = number | null;
